import { render, staticRenderFns } from "./MemberInterviews.vue?vue&type=template&id=12347b37"
import script from "./MemberInterviews.vue?vue&type=script&lang=js"
export * from "./MemberInterviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports